module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0015392_logo.fe659308.png";